'use strict';exports.__esModule = true;exports.generateRecentSearch = undefined;var _head = require('lodash/head');var _head2 = _interopRequireDefault(_head);
var _last = require('lodash/last');var _last2 = _interopRequireDefault(_last);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _set = require('lodash/set');var _set2 = _interopRequireDefault(_set);
var _upperFirst = require('lodash/upperFirst');var _upperFirst2 = _interopRequireDefault(_upperFirst);
var _constants = require('../constants');
var _beautifyNumber = require('../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var dataMapForRecentSearch = [
['city_en', 'locationSearch.en.city_name'],
['city_he', 'locationSearch.he.city_name'],
['option_type', 'optionType'],
['section', 'location'],
['types', 'params.types'],
['rooms', 'params.rooms'],
['price_min', 'params.price.minPrice'],
['price_max', 'params.price.maxPrice']];


var generateRecentSearch = exports.generateRecentSearch = function generateRecentSearch(routeData) {return dataMapForRecentSearch.
  reduce(function (acc, _ref) {var storagePath = _ref[0],dataPath = _ref[1];
    var value = (0, _get2.default)(routeData, dataPath);

    if (value) {
      var serialized = value instanceof Array ?
      value.map(function (item) {return item.toString();}) :
      value.toString();

      return (0, _set2.default)(acc, storagePath, serialized);
    }

    return acc;
  }, {});};

var composeSearchTitle = function composeSearchTitle(titleObject) {
  var searchTitle = [];

  if (titleObject.city) {
    searchTitle.push(titleObject.city);
  }

  if (titleObject.types) {
    searchTitle.push(titleObject.types + ' ' + titleObject.optionType);
  }

  if (titleObject.rooms) {
    searchTitle.push(titleObject.rooms);
  }

  if (titleObject.price) {
    searchTitle.push(titleObject.price);
  }

  return (0, _upperFirst2.default)(searchTitle.map(function (item) {return item.toLowerCase();}).join(', '));
};

var getTitleKeyBySection = function getTitleKeyBySection(section) {
  switch (section) {
    case 'homes':return 'realEstateApartments';
    case 'projects':return 'projects';
    case 'commercial':return 'realEstateCommercial';
    default:return 'realEstateApartments';}

};

var buildRecentSearchTitle = function buildRecentSearchTitle() {var searchData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var locale = arguments[1];var translate = arguments[2];var
  types = searchData.types,rooms = searchData.rooms,price_min = searchData.price_min,price_max = searchData.price_max,option_type = searchData.option_type,section = searchData.section;
  var titleObj = {};

  var cityLang = locale === _constants.language.default ? locale : _constants.language.fallback;
  var cityName = (0, _get2.default)(searchData, 'city_' + cityLang);

  if (cityName) {
    titleObj.city = cityName;
  }

  if (rooms && rooms.length) {
    titleObj.rooms = rooms.length === 1 ?
    (0, _head2.default)(rooms) + ' ' + translate('SEOsearch', 'rooms') :
    (0, _head2.default)(rooms) + '-' + (0, _last2.default)(rooms) + ' ' + translate('SEOsearch', 'rooms');
  }

  var titleKey = getTitleKeyBySection(section);

  titleObj.types = types && types.length === 1 ?
  translate('propertyTypes', types[0]) :
  translate('SEOsearch', titleKey);

  if (price_min || price_max) {
    var minPrice = price_min || '';
    var maxPrice = price_max || '';

    var priceSeparator = minPrice && maxPrice ? ' - ' : '';
    var price = '' + (0, _beautifyNumber2.default)(minPrice) + priceSeparator + (0, _beautifyNumber2.default)(maxPrice);

    if (price) {
      titleObj.price = price;
    }
  }

  titleObj.optionType = '' + translate('SEOsearch', 'optionType', option_type || 'buy');

  var searchTitle = composeSearchTitle(titleObj, translate);

  return searchTitle;
};

var formatRecentSearchData = function formatRecentSearchData() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var locale = arguments[1];var translate = arguments[2];return data.map(function (search) {
    var label = buildRecentSearchTitle(search, locale, translate);
    var value = search.route;

    return {
      label: label,
      value: value };

  });};exports.default =

formatRecentSearchData;


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatRecentSearchData.js
// module id = 1298
// module chunks = 0